import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, Repository } from '@softline/core';
import { TaskCheckpoint, TaskCheckpointPatch } from '../types/task-checkpoint';
import {
  SOFTLINE_API_TASK_CHECKPOINT_BY_ID,
  SOFTLINE_API_TASK_CHECKPOINTS,
} from '../workflow.api';

@Injectable()
export class TaskCheckpointsRepository implements Repository<
  TaskCheckpoint,
  TaskCheckpoint[],
  { taskId: number },
  { taskId: number; checkpointId: number }
> {
  private readonly dataAccess = inject(ApiDataAccess);

  load(params: { taskId: number }): Promise<TaskCheckpoint[]> {
    return this.dataAccess.get<TaskCheckpoint[]>({
      path: SOFTLINE_API_TASK_CHECKPOINTS,
      pathParams: { taskId: params?.taskId },
    });
  }

  create(
    body: Partial<TaskCheckpoint>,
    params: { taskId: number }
  ): Promise<TaskCheckpoint[]> {
    return this.dataAccess.create<Partial<TaskCheckpoint>, TaskCheckpoint[]>(
      { path: SOFTLINE_API_TASK_CHECKPOINTS, pathParams: { taskId: params?.taskId } },
      body
    );
  }

  patch(
    body: TaskCheckpointPatch,
    params: { taskId: number; checkpointId: number }
  ): Promise<TaskCheckpoint[]> {
    return this.dataAccess.patch<TaskCheckpointPatch, TaskCheckpoint[]>(
      {
        path: SOFTLINE_API_TASK_CHECKPOINT_BY_ID,
        pathParams: { taskId: params?.taskId, checkpointId: params?.checkpointId },
      },
      body
    );
  }

  delete(params: { taskId: number; checkpointId: number }): Promise<TaskCheckpoint[]> {
    return this.dataAccess.delete<TaskCheckpoint[]>({
      path: SOFTLINE_API_TASK_CHECKPOINT_BY_ID,
      pathParams: { taskId: params?.taskId, checkpointId: params?.checkpointId },
    });
  }

  update(
    body: TaskCheckpoint,
    params: { taskId: number; checkpointId: number }
  ): Promise<TaskCheckpoint[]> {
    throw new Error('No Endpoint implemented.'); //TODO: WHY WOULD SOME CALL IT REST API AND MAKE IT NOT RESTFUL :)
  }
}
